
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AppUiModule } from "../ui";
import { UIRouterModule } from '@uirouter/angular';

import { LandingState, BusinessSelectState, BusinessAddState, SignUpState, ConnectState, LoginState } from './states';
import { TextMaskModule } from 'angular2-text-mask';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { LandingComponent } from './landing';
import { BusinessSelectComponent } from './business-select';
import { BusinessAddComponent } from './business-add';
import { SignUpPageWithBusinessComponent } from './signup-page';
import { ConnectComponent } from './connect';
import { LoginPageComponent } from './login-page';
let STATES = [LandingState, BusinessSelectState, BusinessAddState, SignUpState, ConnectState, LoginState];
/** The NgModule for the SSO feature */
@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({ states: STATES }),
        AppUiModule,
        FormsModule,
        ReactiveFormsModule,
        TextMaskModule,
        RecaptchaModule,
        RecaptchaFormsModule

    ],
    declarations: [
        LandingComponent,
        BusinessSelectComponent,
        BusinessAddComponent,
        SignUpPageWithBusinessComponent,
        ConnectComponent,
        LoginPageComponent
    ],
    exports: [

    ]
})
export class SquareSpaceModule { }